import { mix } from 'polished';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

export default styled(Box)<{ top?: number; bottom?: number; selected?: boolean }>`
	position: absolute;
	width: 10px;
	height: 10px;
	left: 50%;
	top: ${(props) => props.top};
	bottom: ${(props) => props.bottom};
	margin-bottom: -10px;
	transform: translate(-50%, -50%);
	border: 2px solid ${tokens.text.secondary};
	background: ${(props) => props.theme.colors.lightBlueDark};
	border-radius: 5px;

	${(props) =>
		props.selected &&
		`
		background: ${mix(0.75, props.theme.colors.white, props.theme.colors.primary)};
		border-color: ${props.theme.colors.primary};
	`}
`;
